import axios from "@/config/axios.config";
import licenseApi from "@/api/license";

// 门店营业执照
console.log(licenseApi)
export function license(data) {
	return axios({
		method: "post",
        url: licenseApi.listUrl,
		data,
	});
}

// 门店营业执照详情
export function licenseDetail(data) {
	return axios({
		method: "post",
		url: licenseApi.showUrl,
		data,
	});
}